import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledTextFieldLabel = styled.p`
    ${setFontVariant("caption", colorsPalettes.carbon[300])}
    margin: 4px 0 0;
`;

export const StyledTextFieldError = styled.p`
    ${setFontVariant("caption", colorsPalettes.red[400])}
    margin: 4px 0 0;
`;
